<template>
    <div>
        <div class="col-lg-12 px-0 mt-4">
            <ul class="input-table">
                <li
                    class="d-flex justify-content-start"
                    v-if="items.length"
                    v-for="(item, index) in items"
                    :key="index"
                >
                    <div class="input-table-shadow">
                        <div class="d-flex row align-items-center">
                            <div class="col border-right">
                                <core-time-input class="pl-2" placeholder="Origin time" :time.sync="item.originTime"></core-time-input>
                            </div>
                            <div class="col border-right">
                                <input type="text" name="station_origin" disabled :value="item.stationOrigin.name_NL" />
                            </div>
                            <div class="col-3 border-right">
                                <core-time-input placeholder="Destination time" :time.sync="item.destinationTime"></core-time-input>
                            </div>
                            <div class="col">
                                <input type="text" name="station_destination" disabled :value="item.stationDestination.name_NL" />
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      items: this.transportTimes || [],
      stations: [],
      searchQuery: null
    }
  },
  props: {
    transportTimes: {
      type: Array,
      required: true
    }
  },
  watch: {
    items: {
      handler (val) {
        this.$emit('update:transportTimes', val)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/service/schedule/CustomTransportTime.vue